import React from 'react'
import { useTranslations } from '../../hooks/useTranslations'
import ArticleTag from '../atoms/ArticleTag'

const MagazinArticlesTags = ({
  themes,
  selectedTheme,
  showLoadMore,
  onLoadMore,
  onThemeSelected,
}) => {
  const translations = useTranslations()

  return (
    <section className="mt-20 mb-24 overflow-hidden md:mb-36">
      <div className="container">
        <div className="max-w-xl mx-auto">
          <div className="flex flex-wrap items-center mb-8 space-x-3">
            <div className="flex-shrink-0">
              <button
                type="button"
                className="u-btn u-btn--default"
                onClick={onLoadMore}
                disabled={!showLoadMore}
              >
                {translations.loadMoreArticles}
              </button>
            </div>
            <div className="flex-shrink-0 u-p text-[15px]">
              {translations.orFilterByTopic}:
            </div>
          </div>
          <div className="flex flex-wrap">
            {themes?.map(theme => (
              <ArticleTag
                key={theme}
                label={theme}
                selected={selectedTheme === theme}
                onClick={() => onThemeSelected(theme)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default MagazinArticlesTags
